import { render, staticRenderFns } from "./FechaCompromisoComponent.vue?vue&type=template&id=58385796&scoped=true"
import script from "./FechaCompromisoComponent.vue?vue&type=script&lang=js"
export * from "./FechaCompromisoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58385796",
  null
  
)

export default component.exports